import { render, staticRenderFns } from "./PaymentUseBank.vue?vue&type=template&id=158daace"
import script from "./PaymentUseBank.vue?vue&type=script&lang=js"
export * from "./PaymentUseBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports